import logo from '../dip-logo.png';
import {CalendarMonth, Facebook, Instagram, LocalAtm, YouTube} from "@mui/icons-material";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Button,
    Grid,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemText,
    Snackbar,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import React, {useState, useEffect} from "react";
import ReactGA from "react-ga4";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import { InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';
import { Helmet } from 'react-helmet';

export const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const dateToHumanDateStr = dateObj => dayNames[dateObj.getDay()] + " " + monNames[dateObj.getMonth()] + " " + dateObj.getDate() + " " + dateObj.getHours() % 12 + "pm";

export default function Home() {
  let [lessons, setLessons] = useState([]);
  let [alert, setAlert] = useState(null)

  var maxAge = new Date();
  maxAge.setDate(maxAge.getDate() - 14)

  useEffect(() => {
      const fetchCalendar = async() => {
          const url = "https://nzrxe9e4a4.execute-api.us-east-1.amazonaws.com/calendar";
          const cal = await fetch(url)
              .then(res => res.json())
              .then(lessons => lessons.filter((lesson) => new Date(lesson.start).getTime() > maxAge.getTime()))
              .then(lessons => setLessons(lessons))
      }

      fetchCalendar()
  }, [])

  ReactGA.initialize('G-F9YPQWKTFP');
  ReactGA.event({
      category: 'View',
      action: 'Home Page',
      label: 'Home Page Loaded'
  });

  const subscribe = async () => {
      const url = "https://neon2step.us17.list-manage.com/subscribe/post-json?u=903830d4195eb4152596b273e&amp;id=15bcec96b8&amp;f_id=007b7ce0f0&EMAIL=caguru%40gmail.com&c=__jp0"
      const params =  new URLSearchParams({
          EMAIL: document.getElementById('sub_email').value,
          FNAME: document.getElementById('sub_fname').value,
          LNAME: document.getElementById('sub_lname').value
      });

      await fetch(url, {
          method: "POST",
          mode: "no-cors",
          body: encodeURI(params)
      })
      .then(res => {
          if (res.status == 200) {
              alert("hw")
              setAlert({status: 200, msg: res.text()})
          }
      })

      return;
  }

  return (
      <div className="App">
        <Helmet>
            <title>Neon 2 Step Honky Tonk Dance Lessons</title>
            <meta name="description" content="Directions and parking information for Tim's place in Austin, TX." />
        </Helmet>
          <Snackbar
              open={alert}
              autoHideDuration={3000}
              message=""
          />
          <div style={{margin: "auto", textAlign: "center", marginTop:"40px"}}>
              <Box sx={{ borderRadius: '5px' }}>
                 <img src={logo} className="App-logo" alt="logo" />
              </Box>
          </div>

          <Grid container className={"content"} spacing={2}>
                <Grid item sm={12}>
                    <Card>
                        <CardHeader title={"Slow Blues Dance Workshop"} />
                        <CardContent>
                            <Box style={{float: "right"}} ml={2}>   
                                <YouTubeEmbed url="https://youtube.com/shorts/DHr9bl7J4uc?feature=share" width={350}/>
                            </Box>
                            <Typography mb={2} variant="body1">New to blues dancing or used to swing blues? Or a 2-stepper that wants to smooth out your slow dances? Join us for to get smoother, slower and more connected to the music and your partner.</Typography>
                            <Typography mb={2} variant="body2">All levels welcome, no partner necessary</Typography>
                            <Typography m={2} variant="body2">🗓️ Tuesday, Nov 11th, 7:30p</Typography>
                            <Typography m={2} variant="body2">📍 Tim's House South Central Austin (address in confirmation)</Typography>
                            
                        </CardContent>
                        <CardActions>
                            <Button 
                                sx={{ m: 2 }}
                                size="medium" 
                                color="primary"
                                variant="contained"
                                href="https://www.eventbrite.com/e/slow-blues-dance-workshop-tickets-1910129852809?aff=oddtdtcreator"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Register
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item sm={12}>
                    <Card>
                        <CardHeader title={"Big Beautiful Waltz Dance Workshop"} />
                        <CardContent>
                            <Box style={{float: "right"}} ml={2}>   
                                <YouTubeEmbed url="https://www.youtube.com/shorts/-qFfol6CcNs" width={350}/>
                            </Box>
                            <Typography mb={2} variant="body2">There is no better feeling in the world then feeling a breeze running through your hair as you and your partner lay down the most beautiful, flowy waltz as you skate around the dance floor. Its like floating on clouds!</Typography>
                            <Typography mb={2}variant="body2">This information packed dance workshop, graciously hosted by Shady Springs Party Barn, will focus exclusively on big, beautiful waltz that glide confidently through the air. If you have ever wanted to waltz, or you already waltz but want to make it bigger and more graceful, this is the place to be!</Typography>
                            <Typography m={2} variant="body2">🗓️ Wednesday, Nov 19th, 7:00p</Typography>
                            <Typography m={2} variant="body2">📍 Shady Springs Party Barn</Typography>
                            
                        </CardContent>
                        <CardActions>
                            <Button 
                                sx={{ m: 2 }}
                                size="medium" 
                                color="primary"
                                variant="contained"
                                href="https://www.eventbrite.com/e/big-beautiful-waltz-dance-workshop-tickets-1962723143758?aff=oddtdtcreator"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Register
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item sm={12}>
                    <h4>Where to Dance</h4>
                    Check out the <Link href={"https://austin2step.com"}>Austin 2 Step Calendar</Link> for a full list of all the best places to dance.
                </Grid>
                <Grid item sm={12}>
                    <h4>Services</h4>
                    <div>
                        <p>Private Lessons, Group Lessons, and Workshops available.</p>
                    </div>
                </Grid>
                <Grid item sm={12}>
                    <Box sx={{width: "450px"}}>
                    <LiteYouTubeEmbed
                        id="_sCEWExefXY"
                        title="Polka in the Park with Neon 2-Step"
                    />
                    </Box>
                </Grid>
                <Grid item sm={12}>
                    <Box sx={{width: "450px"}}>
                        <LiteYouTubeEmbed
                            id="-p4ohR1EZo8"
                            title="Howlin Blues Party"
                        />
                    </Box>
                </Grid>
          </Grid>

          <div className="FooterStripe">
                      <IconButton href={"https://www.facebook.com/neon2step"}
                                  aria-label="Neon 2 Step Facebook Page"><Facebook/></IconButton>
                      <IconButton href={"https://www.instagram.com/neon2step"}><Instagram/></IconButton>
                      <IconButton href={"https://www.venmo.com/timplode"}><LocalAtm/></IconButton>
                    <Button size="small" id="whereToTwoStep" href={"https://austin2step.com"} variant={"contained"}><span style={{fontFamily: "arial", fontWeight:900, fontSize:"70%"}}>WHERE TO 2-STEP </span> <CalendarMonth/></Button>
          </div>
    </div>
  );
}